import { render, staticRenderFns } from "./MobileAppHeader.vue?vue&type=template&id=dbc19d54&scoped=true&"
import script from "./MobileAppHeader.vue?vue&type=script&lang=js&"
export * from "./MobileAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppHeader.vue?vue&type=style&index=0&id=dbc19d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc19d54",
  null
  
)

export default component.exports